import styles from './TabSelector.module.css' ;

function TabSelector({options , setActiveTab , activeTab}) {
  return (
    <div className={styles.TabSelector}>
        <div className={styles.TabOptionsContainer}>
      {
        options?.map( (item, index) => {
            return <div key={index} className={`${styles.TabOption} ${(activeTab === item.label) && styles.active}`} onClick={() => setActiveTab(item.label)}>
                {item.label}
                </div>

        })
      }
        </div>

    </div>
  )
}

export default TabSelector
